import React, { useRef, useEffect } from "react";
import debounce from "debounce";
import {
  Collapse,
  Grid,
  InputLabel,
  Typography,
  Box,
  FormControl,
  Select,
  MenuItem,
  Tooltip,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import ArrowCircleRightIcon from "@mui/icons-material/ArrowCircleRight";
import YouTube from "react-youtube";
import { getDataByGas } from "../../Functions/APIservice/gasAPI";
import { useWindowDimensions } from "../../Functions/ScreenOperation/useWindowDimension";
import { ExpandMore } from "../../Functions/ScreenOperation/ExpandMore";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { SelectChangeEvent } from "@mui/material";

type BasicMoviesType = {
  part: string;
};

export default function BasicMovies(props: BasicMoviesType) {
  const part = props.part;

  const [ActiveMovieNum, setActiveMovieNum] = React.useState(0);
  const [movies, setMovies] = React.useState<
    { Title: string; Id: string; OnePointAdvice: string }[]
  >([{ Title: "", Id: "", OnePointAdvice: "" }]);
  const { height } = useWindowDimensions();
  const [movieExpanded, setMovieExpanded] = React.useState(true);
  const [boxWidth, setBoxWidth] = React.useState<number | null>(null);

  const boxRef = useRef<HTMLDivElement>(null);

  const handleActiveNumChange = (event: SelectChangeEvent) => {
    setActiveMovieNum(parseInt(event.target.value as string));
  };

  const handleActiveNumNext = () => {
    var num = ActiveMovieNum + 1;
    setActiveMovieNum(num);
  };

  const handleActiveNumPrev = () => {
    var num = ActiveMovieNum - 1;
    setActiveMovieNum(num);
  };

  // APIから映画データを取得
  React.useEffect(() => {
    getDataByGas({
      mode: "part",
      part: part,
    }).then((response) => {
      response
        .json()
        .then(
          (docx: { Title: string; Id: string; OnePointAdvice: string }[]) => {
            setMovies(docx);
          }
        )
        .catch((error) => {
          console.error("Error:", error);
        });
    });
  }, [part]);

  // Boxのサイズをリサイズ
  useEffect(() => {
    if (boxRef.current) {
      const resizeObserver = new ResizeObserver(
        debounce(() => {
          const width = boxRef.current ? boxRef.current.offsetWidth : null;
          setBoxWidth(width);
        }, 300) // debounce the resize event with a delay of 300ms
      );

      if (boxRef.current) {
        resizeObserver.observe(boxRef.current);
      }

      return () => {
        if (boxRef.current) {
          resizeObserver.unobserve(boxRef.current);
        }
      };
    }
  }, [boxRef]);

  // OnePointAdviceを改行で区切ってリストに変換する関数
  function splitOnePointAdvice(onePointAdvice: string): string[] {
    return onePointAdvice.split("\n").filter((line) => line.trim() !== "");
  }

  return (
    <div>
      {movies.length > 0 ? (
        <div>
          <Box sx={{ my: 1 }}>
            <Typography variant="h5" color="text.secondary" textAlign="left">
              関連動画
            </Typography>
          </Box>
          <Box sx={{ backgroundColor: "#ECF5FA", mb: 2 }} ref={boxRef}>
            {boxWidth && (
              <Grid className="BasicMovie">
                <YouTube
                  videoId={movies[ActiveMovieNum].Id}
                  opts={{
                    height: (boxWidth * (9 / 16)).toString(),
                    width: boxWidth.toString(),
                  }}
                />
              </Grid>
            )}

            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              sx={{ mt: 2, mb: 1, mx: 2 }}
            >
              <FormControl sx={{ flexGrow: 1 }}>
                <InputLabel id="movie-select-label">動画を選択</InputLabel>
                <Select
                  labelId="movie-select-label"
                  id="movie-select"
                  value={ActiveMovieNum.toString()}
                  label="動画を選択"
                  onChange={handleActiveNumChange}
                  sx={{ borderRadius: 2, height: 50, bgcolor: "white" }}
                >
                  {movies.map((movie, index) => (
                    <MenuItem key={index} value={index}>
                      {movie.Title}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              {/* <Box display="flex" alignItems="center" sx={{ ml: 2 }}>
                {ActiveMovieNum > 0 && (
                  <Tooltip title="前に戻る">
                    <IconButton color="primary" onClick={handleActiveNumPrev}>
                      <ArrowCircleLeftIcon style={{ fontSize: 40 }} />
                    </IconButton>
                  </Tooltip>
                )}
                {ActiveMovieNum < movies.length - 1 && (
                  <Tooltip title="次に進む">
                    <IconButton color="primary" onClick={handleActiveNumNext}>
                      <ArrowCircleRightIcon style={{ fontSize: 40 }} />
                    </IconButton>
                  </Tooltip>
                )}
              </Box> */}
            </Box>

            {movies[ActiveMovieNum].OnePointAdvice ? (
              <List>
                {splitOnePointAdvice(movies[ActiveMovieNum].OnePointAdvice).map(
                  (advice, index) => (
                    <ListItem
                      key={index}
                      alignItems="flex-start"
                      sx={{ py: 0.5 }}
                    >
                      <ListItemIcon sx={{ minWidth: 30, mt: 0.5 }}>
                        <CheckCircleOutlineIcon sx={{ color: "#FE978A" }} />
                      </ListItemIcon>
                      <ListItemText primary={advice} />
                    </ListItem>
                  )
                )}
              </List>
            ) : (
              <></>
            )}
          </Box>
        </div>
      ) : (
        <div>データ取得中...</div>
      )}
    </div>
  );
}
